// {
//     "country": "中华人民共和国",
//     "province": "重庆市",
//     "city": "重庆市",
//     "citycode": "023",
//     "adcode": "500000",
//     "bounds": [
//         105.28976,
//         28.160225,
//         110.199858,
//         32.201187
//     ],
//     "status": 0,
//     "position": [
//         106.504962,
//         29.533155
//     ],
//     "location_type": "ipcity",
//     "isConverted": true,
//     "message": "Get city by ip success."
// }
// 调用愉快办定位方法 获取经纬度
export const getLocation = () => {
  const jsapiToken = sessionStorage.getItem("jsapiToken"); // 替换为实际的JSAPI令牌
  const getAddress = sessionStorage.getItem("address"); // 替换为实际的JSAPI令牌
  if (getAddress) return;
  AlipayJSBridge.call(
    "getYkbAuthCode",
    {
      // appId: "4caf01f7-ac03-4432-aa5f-0d3a12efe32c",
      // appId: "36575343-9952-46d4-82c6-3fe79a23b7b1",
      appId: process.env.VUE_APP_ID,
      forceScopes: ["ykb_divide"],
      jsapiToken,
    },
    function (result) {
      if (result.code == 0) {
        AlipayJSBridge.call(
          "location",
          {
            jsapiToken: jsapiToken,
            authCode: result.data.authCode,
          },
          function (resp) {
            const address = {
              province: "重庆市",
              city: "重庆市",
              adcode: "500000",
              position: [resp.longitude, resp.latitude],
            };
            sessionStorage.setItem("address", JSON.stringify(address));
          },
        );
      }
    },
  );
};

export const getLocationWeixin = () => {
  const jsapiToken = sessionStorage.getItem("jsapiToken"); // 替换为实际的JSAPI令牌
  const getAddress = sessionStorage.getItem("address");
  if (getAddress) return;
  MyYkb.call(
    "getCurrentLocation",
    {
      // appId: process.env.VUE_WEIXIN_ID,
      // 测试
      // appId: "ce7c8408-c982-4797-8b12-7e421b93020f",
      // 正式
      appId: 'dff7015a-ef4c-4c59-882b-dec5e5a0e4ae',
      forceScopes: ["wechat_xcx_location"],
      jsapiToken,
    },
    function (data) {
      if (data !== undefined) {
        const location = data.split(",");
        const address = {
          province: "重庆市",
          city: "重庆市",
          adcode: "500000",
          position: [location[0], location[1]],
        };
        sessionStorage.setItem("address", JSON.stringify(address));
      }
    },
  );
};
